import { CheckCircle2, CircleAlert, Info, X } from 'lucide-react'
import { useEffect, useState } from 'react'

type ActionToastProps = {
  message: string
  title?: string
  tone?: 'success' | 'error' | 'info'
  onDismiss: () => void
}

export function ActionToast({
  message,
  title,
  tone = 'success',
  onDismiss
}: ActionToastProps) {
  const [leaving, setLeaving] = useState(false)

  useEffect(() => {
    setLeaving(false)

    const leaveTimer = window.setTimeout(() => setLeaving(true), 3600)
    const dismissTimer = window.setTimeout(onDismiss, 4000)

    return () => {
      window.clearTimeout(leaveTimer)
      window.clearTimeout(dismissTimer)
    }
  }, [message, onDismiss])

  const Icon = tone === 'error' ? CircleAlert : tone === 'info' ? Info : CheckCircle2

  return (
    <div
      className={`action-toast action-toast-${tone}${leaving ? ' is-leaving' : ''}`}
      role={tone === 'error' ? 'alert' : 'status'}
      aria-live="polite"
    >
      <div className="action-toast-icon"><Icon size={18}/></div>
      <div className="action-toast-copy">
        {title && <strong>{title}</strong>}
        <span>{message}</span>
      </div>
      <button
        type="button"
        className="action-toast-close"
        onClick={onDismiss}
        aria-label="Dismiss notification"
      >
        <X size={15}/>
      </button>
    </div>
  )
}
